<template>
  <div class="l-dropdown-section py-4" role="none">
    <slot />
  </div>
</template>
